import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const Text = styled.span`
  margin: 16px;
  color: ${props => props.theme.colors.color545e6c};
  font-size: 16px;
  font-family: 'Inter';
  text-align: center;
`
